const baseCompanyOfficeApiUrls = "/api/Company";

export const CompanyOfficeApiUrl = {
  GetOffices: `${baseCompanyOfficeApiUrls}/GetOffices`,
  AddOffices: `${baseCompanyOfficeApiUrls}/Office`,
  UpdateOffices: `${baseCompanyOfficeApiUrls}/UpdateOffice`,
  DeleteOffice: `${baseCompanyOfficeApiUrls}/DeleteOffice`,
  /** "Same clinic for every site" (Epic 6303, story 6373). */
  SitesServicingClinic: `${baseCompanyOfficeApiUrls}/SitesServicingClinic`,
  SiteRegions: (companyRowID) =>
    `${baseCompanyOfficeApiUrls}/SiteRegions?companyRowID=${companyRowID}`,
  GetPrimaryOfficeID: (companyRowID) =>
    `${baseCompanyOfficeApiUrls}/GetPrimaryOfficeID?companyRowID=${companyRowID}`,
};
